/* eslint-disable no-undef */
import { convertHMS, onReady } from "/Assets/js/utilities.js";
import vidyardEmbed from "@vidyard/embed-code";

export default class ListingPages {
    init() {
        onReady(() => {
            // TODO - remove dependence on jquery

            if (window.location.href.indexOf("global-landing-page") === -1) {
                this.customSearch();
            }

            $("[lsp-input]").on("keypress", function (event) {
                if (event.which == 13) {
                    $('[lps-form="' + $(this).attr("lsp-input") + '"]').submit();
                }
            });

            $("[lps-expand]").on("click", function () {
                var self = $(this);
                var expandData = self.attr("lps-expand-data");
                var scrollTo = self.attr("lps-expand-scrollto");
                $("[lps-expand-data=" + expandData + "]").show();
                self.hide();
                if (scrollTo != undefined) $(scrollTo).scrollIntoView();
            });

            vidyardEmbed
                ? this.updateVideoDurations()
                : document.addEventListener("onVidyardAPI", ({ detail: vyApi }) => init(vyApi));
        });
    }

    videoPaginationComplete() {
        this.updateVideoDurations();
    }

    updateVideoDurations() {
        var vids = $("#VideoListingUpdatePanel").find("[data-video-source-url]");

        $(vids).each(function (i, obj) {
            var vidDuration;
            var url = $(obj).data("video-source-url");
            var pieces = url.split(/[/]+/);
            var videoId = pieces[pieces.length - 1].replace(/\?*$/, "");

            vidyardEmbed.api
                .getPlayerMetadata(videoId)
                .then((metadata) => {
                    vidDuration = metadata.length_in_seconds;
                    $(obj)
                        .find("[data-video-duration]")
                        .text(convertHMS(vidDuration));
                })
                .catch(() => {
                    console.error("error fetching player metadata");
                });
        });
    }

    customSearch() {
        // Submit the form if the user presses enter in a search input
        $(".search-group.no-suggestions input.search")
            .on("keypress", function (e) {
                var code = e.keyCode ? e.keyCode : e.which;
                if (code == 13) {
                    e.preventDefault();
                    e.stopPropagation();
                    $(this)
                        .closest("form")
                        .submit();
                }
            })
            .on("propertychange input", function (e) {
                var valueChanged = false;

                if (e.type == "propertychange") {
                    valueChanged = e.originalEvent.propertyName == "value";
                } else {
                    valueChanged = true;
                }
                if (valueChanged) {
                    var newVal = $(this).val();
                    var clearSearch = $(this)
                        .parent()
                        .find(".clear-search");
                    newVal.length == 0 ? clearSearch.hide() : clearSearch.show();
                }
            })
            .each(function () {
                var clearSearch = $(this)
                    .parent()
                    .find(".clear-search");
                $(this).val().length == 0 ? clearSearch.hide() : clearSearch.show();
            });

        // Clear the search input if the user clicks the clear link
        $(".search-group.no-suggestions .clear-search").on("click", function () {
            $(this)
                .parents(".input-group")
                .find("input.search")
                .val("")
                .focus();
            $(this).hide();
        });
    }
}
